export default __webpack_public_path__ + "static/media/B165.e89e89d5.png";